/*
*
* File JS per la pagina singola del blog
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBase from '../../components/hero-base/hero-base';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './blog-single.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{
    heroBase();
});

//--------------------------------------------------------------------//